export default "__VITE_ASSET__DNB6AF37__"